export default "__VITE_ASSET__8ILuHETv__"